export default __webpack_public_path__ + "locales/ko-KR/MainBar.json?hash=97b0100aa849d1a154fe61256e85b1e9";